// src/UserContext.js
import React, { createContext, useState, useEffect } from "react";
import { auth, database } from "./firebaseConfig";
import { onAuthStateChanged } from "firebase/auth";
import { ref, set, onValue } from "firebase/database";

export const UserContext = createContext({
  currentUser: null,
  users: {},
});

export const UserProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [users, setUsers] = useState([]);

  const createUserRecordinDb = async (user) => {
    const userRef = ref(database, `users/${user.uid}`);
    set(userRef, {
      displayName: user.displayName,
      email: user.email,
    }).catch((error) => {
      console.error("Error registering the user", error);
      alert("Failed to register a user. Please try again.");
    });
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        // User is signed in
        setCurrentUser(user);
      } else {
        // User is signed out
        setCurrentUser(null);
      }
    });

    // Fetch users
    const usersRef = ref(database, "users");
    const unsubscribeUsers = onValue(
      usersRef,
      (snapshot) => {
        const data = snapshot.val();
        setUsers(data || {});
      },
      (error) => {
        console.error("Error fetching users:", error);
      }
    );

    return () => {
      unsubscribe();
      unsubscribeUsers();
    };
  }, []);

  const value = {
    currentUser,
    users,
    createUserRecordinDb,
  };

  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};

export default UserProvider;
